(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klavio-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class KlavioSegment extends HTMLElement {
      static searchParams = 'klavio_search';
      static publicKey = 'YrwgTA';
      static klavioEndPoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${KlavioSegment.publicKey}`;

      constructor() {
        super();

        this.dismissTimeout = null;
        this.formElement = this.querySelector('form');
        this.boundSubmitHandler = this.onSubmit.bind(this);
        this.klavioSegment = this.dataset.segment;
        this.inputProductHidden = this.querySelector("input[name='klavioProduct']");
        this.formNotificationText = this.querySelector('.klavio-form__notification');
        this.notificationTexts = JSON.parse(this.querySelector('script[klavio-segment-notification]').textContent);

        this.formNotification = this.searchConfig = {
          isFounded: false,
          value: 'Default',
          name: KlavioSegment.searchParams,
        };
      }

      connectedCallback() {
        this.searchConfig = {
          ...this.searchConfig,
          ...this.getSearchParam(this.searchConfig.name),
        };

        this.formElement.addEventListener('submit', this.boundSubmitHandler);
        const { value } = this.searchConfig;
        if (this.inputProductHidden) this.inputProductHidden.value = value;
      }

      disconnectedCallback() {
        this.formElement.removeEventListener('submit', this.boundSubmitHandler);
      }

      async onSubmit(event) {
        event.preventDefault();

        const submittedFormData = new FormData(this.formElement);
        const parsedData = this.extractFormData(submittedFormData);

        const { message, status } = await this.klavioSubmit(parsedData);

        this.showNotification(message, status);
      }

      async klavioSubmit(payload) {
        const submissionResult = {
          message: '',
          status: 'error',
        };

        try {
          const config = this.createConfig(payload);
          const endPoint = KlavioSegment.klavioEndPoint;
          const response = await fetch(endPoint, config);

          if (!response.ok) {
            throw new Error(this.notificationTexts.main_error_notificaton || 'Failed to add to list segment.');
          }
          submissionResult.message =
            this.notificationTexts.main_notificaton ||
            this.notificationTexts.fallback_notificaton ||
            'Successfully added to the list segment.';
          submissionResult.status = 'success';
        } catch (error) {
          console.error(error);
          submissionResult.message =
            error.message || this.notificationTexts.fallback_error_notificaton || 'An unexpected error occurred.';
        } finally {
          this.resetForm();
          return submissionResult;
        }
      }

      createConfig(payload) {
        const { email, first_name, last_name, ...rest } = payload;

        if (!email) {
          throw new Error(this.notificationTexts.email_error_notificaton || 'Email is required.');
        }

        if (!this.klavioSegment) {
          throw new Error('klavioSegment id is required.');
        }

        const attributes = {
          ...(email && { email }),
          ...(first_name && { first_name }),
          ...(last_name && { last_name }),
          properties: {
            ...rest,
          },
        };

        const body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Custom Klavio form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: attributes,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: this.klavioSegment,
                },
              },
            },
          },
        };

        return {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-07-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify(body),
        };
      }

      extractFormData(formData) {
        return Object.fromEntries(formData.entries());
      }

      getSearchParam(paramName) {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;

        return {
          isFounded: searchParams.has(paramName),
          value: searchParams.get(paramName) || 'Default',
        };
      }

      resetForm() {
        const { isFounded, name } = this.searchConfig;
        if (isFounded) {
          const url = new URL(window.location.href);
          const searchParams = url.searchParams;
          searchParams.delete(name);
          const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
          window.history.replaceState({}, '', newUrl);
        }
        this.formElement?.reset();
      }

      showNotification(message, status) {
        if (!this.formNotificationText) return;

        if (this.dismissTimeout) clearTimeout(this.dismissTimeout);

        this.formNotificationText.textContent = message;
        this.formNotificationText.classList.add(
          'klavio-form__notification--show',
          `klavio-form__notification--${status}`
        );

        this.dismissTimeout = setTimeout(() => {
          this.formNotificationText.classList.remove(
            'klavio-form__notification--show',
            `klavio-form__notification--${status}`
          );
        }, 3000);
      }
    }

    if (!customElements.get('klavio-segment')) {
      customElements.define('klavio-segment', KlavioSegment);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
